module.exports = __webpack_public_path__ + "static/media/logo.60666920.svg";